import querystring from "querystring"

// Function Send email
export async function sendEmail(mailFrom, mailReplyTo, mailTo, mailSubject, mailBody) {
  const API_ENDPOINT = window.location.origin + "/.netlify/functions/sendEmail"
  const secretKey = process.env.GATSBY_AMAZON_SECRET
  const params = {
    mailFrom,
    mailReplyTo,
    mailTo,
    mailSubject,
    mailBody,
    secretKey
  }

  return (
    fetch(API_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: querystring.stringify(params)
    })
      // .then(response => {
      //   return response.json()
      // })
      // .then(data => {
      //   console.log(data.response)
      //   return data
      // })
      .catch(error => {
        console.error("ERROR ==> ", error)
      })
      .then(response => {
        // console.log("SUCCESS ==> ", response)
        return response
      })
  )
}
// END : Function Send email
